import graphQLSegmentsApiService from "./GraphQLSegmentsApiService";
import apiService from "./apiService";
import segmentsApiService from "./SegmentsApiService";
import appApiService from "./AppApiService";
import audienceApiService from "./audienceApiService";
import packageApiService from "./packageApiService";
import packageModalApiService from "./packageModalApiService";
import llmApiService from "./LLMapiService";

export const switchEnvironment = (proxyUrl) => {
  // GraphQLSegmentsApiService also handles localStorage persistence and /api stripping for graphql
  graphQLSegmentsApiService.setProxyUrl(proxyUrl);
  apiService.setProxyUrl(proxyUrl);
  segmentsApiService.setProxyUrl(proxyUrl);
  appApiService.setProxyUrl(proxyUrl);
  audienceApiService.setProxyUrl(proxyUrl);
  packageApiService.setProxyUrl(proxyUrl);
  packageModalApiService.setProxyUrl(proxyUrl);
  llmApiService.setProxyUrl(proxyUrl);
};
